import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerTrack = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: "\n    .spinner-track {\n    transform-origin: center;\n    animation: track-animation 0.75s infinite linear;\n  }\n  @keyframes track-animation {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  " }),
		/* @__PURE__ */ _jsx("path", {
			d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
			opacity: .25,
			stroke: "currentColor",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
			className: "spinner-track",
			stroke: "currentColor",
			fill: "currentColor"
		})
	]
});
export default SvgSpinnerTrack;
